import {get} from 'lodash';
import { fetchMoreByState, fetchBySearch } from '../actions/api';
import {
  setCurrentCategoryIndex,
  setProductFetching,
  fetchProducts,
  searchProducts,
  FETCH_PRODUCTS
} from '../actions/product';
import { nextPage, resetLazyLoader } from "../actions/lazyload";
import {
  FILTER_CATEGORY_ID,
  FILTER_CATEGORY_NAME,
} from "../const/filter_const";
import { FETCH_PRODUCTS_COMPLETE, SEARCH_PRODUCTS } from '../reducers/productReducer';
import { hideLoader, showLoader } from '../helpers/loader';

const LIMIT_PER_PAGE = 20;
const BOTTOM_OFFSET = 100;
const MIN_PRODUCT_LENGTH_TO_FILL_SPACE = 8;

const productMiddleware = store => next => (action) => {
  const { products, lazyLoad, config } = store.getState();

  if (action.type === FETCH_PRODUCTS_COMPLETE) {
    const nextCategoryIndex = products.currentCategoryIndex + 1;
    const totalProductLength = get(products, 'data.length', 0);
    const categoryLength = get(config, 'categories.length', 0);

    if (products.data) {
      hideLoader();
    }

    if (products.isInfiniteScroll) {
      if (
        (totalProductLength < MIN_PRODUCT_LENGTH_TO_FILL_SPACE)
        || ((nextCategoryIndex < categoryLength)
            && (window.innerHeight + window.scrollY >= document.body.offsetHeight - BOTTOM_OFFSET))
      ) {
        store.dispatch(fetchProducts());
      }
    }
  }

  if (action.type === FETCH_PRODUCTS) {
    if (lazyLoad.justMadeReq) {
      next(action);
      return;
    }

    if (!lazyLoad.lastPage) {
      store.dispatch(nextPage());
      store.dispatch(fetchMoreByState(LIMIT_PER_PAGE));
      next(action);
      return;
    }
    /**
     * When you go to online menu you able to scroll through 
     * full list of products that are available.
     * Triggered if infiniteScroll is on and total products less than 8.
     * See CONCAT_PRODUCTS statement down below.
     */
    if (products.isInfiniteScroll && products.activeCategoryIndex === -1) {
      const nextCategory = products.currentCategoryIndex + 1;
      if (nextCategory < config.categories.length) {
        store.dispatch(setCurrentCategoryIndex(nextCategory));
        store.dispatch(resetLazyLoader());
        store.dispatch(nextPage());
        store.dispatch(fetchMoreByState(LIMIT_PER_PAGE));
        next(action);
        return;
      }
    }
  }

  if (action.type === SEARCH_PRODUCTS) {
    if (lazyLoad.justMadeReq) {
      next(action);
      return;
    }

    if (!lazyLoad.lastPage) {
      store.dispatch(nextPage());
      store.dispatch(fetchBySearch(LIMIT_PER_PAGE));
      next(action);
      return;
    }
  }

  if (action.type === 'SET_PRODUCTS') {
    store.dispatch(setProductFetching(false));
    hideLoader();
    
    const { categories } = config;
    let selectedCategoryIndex;
    if (action.payload.category === FILTER_CATEGORY_NAME) {
      selectedCategoryIndex = FILTER_CATEGORY_ID;
    } else {
      selectedCategoryIndex = categories.findIndex((cat, index) => cat.name.toLowerCase() === action.payload.category.toLowerCase());
    }
    store.dispatch(setCurrentCategoryIndex(selectedCategoryIndex));
    store.dispatch({type: 'CLEAN_PRODUCTS_DATA'});
    store.dispatch({type: 'SET_PRODUCTS_DATA', payload: action.payload});
  }

  if (action.type === 'CONCAT_PRODUCTS') {
    store.dispatch(setProductFetching(false));
    store.dispatch({type: 'CONCAT_PRODUCTS_DATA', payload: action.payload});
  }

  if (action.type === 'RESET_PRODUCTS') {
    store.dispatch(fetchProducts());
  }

  if (action.type === 'RESET_SEARCH') {
    store.dispatch(searchProducts());
  }
  next(action);
};

export default productMiddleware;



// WEBPACK FOOTER //
// ./src/middleware/productMiddleware.js